import useCollectionUpdate, {
  DixaResourceInputWithName,
} from './useCollectionUpdate';

export type { DixaResourceInputWithName };

export default useCollectionUpdate;
